import React, { useEffect, useState } from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import styles from "../RawData/Header/Header.module.sass";
import {
    SovosToolbar,
    SovosToolbarActions,
    SovosMenuItem,
    SovosToolbarDropdown,
    SovosBox,
    SovosTypography,
} from "mosaic-react";
import HeaderEditMode from "../RawData/Header/HeaderEditMode";

const CustomCsvRawDataHeader = (props) => {
    const {
        getCustomCsvTablesAvailable,
        title,
        editMode,
        setEditMode,
        onClickSave,
        list,
        rawDataEdit,
        disableEditModeButton = false
    } = props;
    const { history, params, i18n } = useGlobalValue();
    const { projectId, modulePrefix, fiscalYear, entityRawData, importId } = params;
    const [arrayImportIds, setArrayImportIds] = useState([]);
    const [currentFile, setCurrentFile] = useState(entityRawData || "");

    // Extract importId from pathname if not in params
    const getImportId = () => {
        if (importId) return importId;
        const pathParts = history.location.pathname.split("/");
        // Pattern: /locale/projectId/fiscalYear/importId/...
        if (pathParts.length >= 5) {
            return pathParts[4] || "full";
        }
        return "full";
    };

    useEffect(() => {
        getCustomCsvTablesAvailable(projectId, modulePrefix)
            .then((res) => {
                const { custom_csv_tables_available } = res;
                setArrayImportIds(custom_csv_tables_available || []);
            })
            .catch((error) => console.error(error));
    }, [projectId, modulePrefix, fiscalYear, getCustomCsvTablesAvailable]);

    // Auto-select first table if available and no entity is selected
    useEffect(() => {
        if (arrayImportIds?.length > 0 && !entityRawData) {
            const firstTable = arrayImportIds[0];
            setCurrentFile(firstTable);
            // Build the path ensuring custom_templates is included
            const importIdValue = getImportId();
            const localeValue = params.locale || "en";
            const basePath = `/${localeValue}/${projectId}/${fiscalYear}/${importIdValue}`;
            const modulePath = modulePrefix ? `/${modulePrefix}` : "";
            const newPath = `${basePath}${modulePath}/${firstTable}`;
            // Preserve existing query params or add viewMode=source
            const searchParams = new URLSearchParams(history.location.search);
            if (!searchParams.has("viewMode")) {
                searchParams.set("viewMode", "source");
            }
            const newHistory = searchParams.toString()
                ? `${newPath}?${searchParams.toString()}`
                : newPath;
            history.push(newHistory);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrayImportIds, entityRawData, history, params, projectId, fiscalYear, modulePrefix]);

    return (
        <div key="mainDiv">
            <div className={`${styles["header-root"]}`}>
                {!disableEditModeButton ? <SovosBox
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginLeft: "24px",
                        marginRight: "24px",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        borderBottom: "1px solid rgb(219, 224, 229)",
                    }}
                >
                    <SovosTypography variant={"h4"}>{title}</SovosTypography>
                    <HeaderEditMode
                        editMode={editMode}
                        setEditMode={setEditMode}
                        onClickSave={onClickSave}
                        params={params}
                        list={list}
                        rawDataEdit={rawDataEdit}
                    />
                </SovosBox>
                    : null}
                <div className={`${styles["toolbar-container"]}`}>
                    <SovosToolbar className={`${styles["sovos-toolbar"]}`}>
                        <SovosToolbarActions className={`${styles["toolbar-actions"]}`}>
                            <SovosToolbarDropdown
                                className={`${styles["toolbar-dropdown"]}`}
                                value={
                                    (arrayImportIds || []).includes(currentFile)
                                        ? currentFile
                                        : entityRawData || ""
                                }
                                onChange={(event) => {
                                    setCurrentFile(event.target.value);
                                    const tableName = event.target.value.trim();
                                    // Build the path ensuring custom_templates is included
                                    const importIdValue = getImportId();
                                    const localeValue = params.locale || "en";
                                    const basePath = `/${localeValue}/${projectId}/${fiscalYear}/${importIdValue}`;
                                    const modulePath = modulePrefix ? `/${modulePrefix}` : "";
                                    const newPath = `${basePath}${modulePath}/${tableName}`;
                                    // Preserve existing query params or add viewMode=source
                                    const searchParams = new URLSearchParams(history.location.search);
                                    if (!searchParams.has("viewMode")) {
                                        searchParams.set("viewMode", "source");
                                    }
                                    const newHistory = searchParams.toString()
                                        ? `${newPath}?${searchParams.toString()}`
                                        : newPath;
                                    history.push(newHistory);
                                }}
                            >
                                {arrayImportIds?.length ? (
                                    arrayImportIds.map((name) => (
                                        <SovosMenuItem key={name} value={name}>
                                            {name}
                                        </SovosMenuItem>
                                    ))
                                ) : (
                                    <SovosTypography sx={{ padding: "5px" }}>
                                        {i18n`No options available`}
                                    </SovosTypography>
                                )}
                            </SovosToolbarDropdown>
                        </SovosToolbarActions>
                    </SovosToolbar>
                </div>
            </div>
        </div>
    );
};

export default CustomCsvRawDataHeader;
